import { useModal } from "@/Contexts";
import { useGlobalAlert } from "@/States/globalAlert";
import { trpc } from "@/Utils/trpc";
import { useNavigate } from "@/Utils/useNavigate";
import ErrorNotice from "@/components/ErrorNotice";
import ModalContainer from "@/components/modalContainer";
import { useTrans } from "@/translations";

import { FC } from "react";
import { useForm } from "react-hook-form";

import { AllocationForm, AllocationFormData } from "./allocationForm";

type Props = {
  onSuccess: () => void;
};

export const CreateAllocationModal: FC<Props> = ({ onSuccess }) => {
  const {
    mutate,
    isPending: isLoading,
    isError,
  } = trpc.allocations.create.useMutation();
  const { setGlobalAlert } = useGlobalAlert();
  const navigate = useNavigate();
  const { t } = useTrans();
  const { hideModal } = useModal();
  const formHandler = useForm<AllocationFormData>();

  const { handleSubmit } = formHandler;

  const onConfirm = handleSubmit((fieldData) => {
    const geoLocationCode = `${fieldData.municipalityNumber}.${fieldData.streetCode}.${fieldData.houseNumber}`;
    const allocationData = {
      geoLocationCode,
      geoLocationName: fieldData.name,
    };
    mutate(allocationData, {
      onSuccess: (id) => {
        hideModal();
        setGlobalAlert({
          type: "success",
          message: "systemMessages:allocationAdded",
        });
        onSuccess();
        navigate(`/allocations/${id}`);
      },
      onError: () => {
        setGlobalAlert({
          type: "error",
          message: "errors:failedSave",
        });
      },
    });
  });

  return (
    <ModalContainer
      title="actions:createAllocation"
      onConfirm={onConfirm}
      onCancel={hideModal}
      onConfirmLoading={isLoading}
      className="w-1/2 lg:w-1/3"
    >
      {isError ? (
        <ErrorNotice />
      ) : (
        <AllocationForm
          title={t("drawerLabels:allocation")}
          formHandler={formHandler}
        />
      )}
    </ModalContainer>
  );
};
